var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoboChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16956",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12598",
    d: "M15.832 2.5a11.649 11.649 0 00-9.906 17.805L3.75 26.25l5.944-2.176A11.661 11.661 0 1015.832 2.5h0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12599",
    d: "M18.12 10a3.311 3.311 0 013.13 3.373c0 3.3-5.217 6-5.312 6s-5.312-2.7-5.312-6A3.311 3.311 0 0113.755 10a2.815 2.815 0 012.182 1 2.81 2.81 0 012.183-1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12600",
    d: "M0 0h30v30H0z",
    fill: "none"
  })));
}
export default SvgRoboChat;


//////////////////
// WEBPACK FOOTER
// ./src/icons/RoboChat.svg
// module id = 171
// module chunks = 11